import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AuthWrapper from './components/AuthWrapper';
import AppRouter from './components/Router';
import ErrorBoundary from './components/ErrorBoundary';

const AppContent: React.FC = () => {
  const { user, isAuthenticated } = useAuth();

  // Check if we're on a password reset page (from email link)
  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash;
  const hashParams = new URLSearchParams(hash.substring(1));
  const type = urlParams.get('type') || hashParams.get('type');
  const isPasswordResetFlow = type === 'recovery';

  // Show login screen if not authenticated OR if we're in a password reset flow
  if (!isAuthenticated || !user || isPasswordResetFlow) {
    return <AuthWrapper />;
  }

  // Show the main application with router
  return <AppRouter />;
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;